export default __webpack_public_path__ + "static/media/filled_man.f483eae5.svg";